import { initializeApp } from "firebase/app";
import { Firestore, getFirestore } from "@firebase/firestore";
import { GoogleAuthProvider, getAuth, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDijmI6dDmOkO_ErTB-DqxyjO06KC4HbTI",
  authDomain: "grinleaf-a36f2.firebaseapp.com",
  projectId: "grinleaf-a36f2",
  storageBucket: "grinleaf-a36f2.appspot.com",
  messagingSenderId: "112128718408",
  appId: "1:112128718408:web:a25574efe59b420944ca7d",
  measurementId: "G-C172FWKNBG",
};

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account",
});
googleProvider.addScope("email");

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const firestore: Firestore = getFirestore(app);

export const auth = getAuth(app);
export const signInWithGooglePopup = () =>
  signInWithPopup(auth, googleProvider);
